// extracted by mini-css-extract-plugin
export default {"card":"Card_card__3y7iZ","cardHeader":"Card_cardHeader__OhLWW","cardContent":"Card_cardContent__0xRdR"};